import { gql } from '@apollo/client';

export const SET_SERVICE_ACTIVE_MUTATION = gql`
    mutation SetServiceActive($uuid: String!, $active: Boolean!) {
        setServiceActive(uuid: $uuid, active: $active) {
            uuid
            active
        }
    }
`;

export const UPSERT_SERVICE_MUTATION = gql`
    mutation UpsertService($input: AppointmentServiceInput!) {
        upsertService(input: $input) {
            uuid
            name
            description
            durationMinutes
            price
            active
            species
            bufferBeforeMinutes
            bufferAfterMinutes
        }
    }
`;
